<template>
  <div id="grid-contratacion">
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex xs12 md4>
          <v-select
            v-model="rc_inhabilitadoValue"
            :items="rc_inhabilitadoSelect"
            label="RC-Inhabilidad"
            data-vv-name="listaNiveles"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="capacitacionValue"
            :items="capacitacionSelect"
            label="Capacitacion"
          >
          </v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="cap_aptoValue"
            :items="cap_aptoSelect"
            label="Resultado Capacitacion"
          >
          </v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="regionValue"
            :items="regionSelect"
            label="Region"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="comunaValue"
            :items="comunaSelect"
            label="Comuna"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="cargoValue"
            :items="cargoSelect"
            label="Cargo"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="tipo_capValue"
            :items="tipo_capSelect"
            label="Tipo Capacitacion"
          ></v-select>
        </v-flex>
        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="filterCandidatos()"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="itemsDocumento"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">
                {{ props.item.rut + "-" + props.item.dv }}
              </td>
              <td class="text-xs-left">{{ props.item.rc_inhabilitado }}</td>
              <td class="text-xs-left">{{ props.item.capacitacion }}</td>
              <td class="text-xs-left">{{ props.item.cap_apto }}</td>
              <td class="text-xs-left">{{ props.item.estado }}</td>
              <td>
                <v-btn
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="green darken-4"
                  small
                  title="Ver candidato"
                  @click="viewCandidato(props.item.id)"
                >
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <v-btn
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="blue darken-4"
                  small
                  title="Contratado"
                  @click="contratado(props.item.id)"
                >
                  <v-icon>done</v-icon>
                </v-btn>
                <v-btn v-if="getCodigoPerfil() != 'LEC' && !isContratoCerrado()"
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="red darken-4"
                  small
                  title="Sin Contratar"
                  @click="sinContratar(props.item.id)"
                >
                  <v-icon>clear</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="green darken-4"
              small
            >
              <v-icon>remove_red_eye</v-icon> </v-btn
            >Ver candidatos
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="blue darken-4"
              small
            >
              <v-icon>done</v-icon> </v-btn
            >Contratado
            <v-btn v-if="getCodigoPerfil() != 'LEC' && !isContratoCerrado()"
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="red darken-4"
              small
            >
              <v-icon>clear</v-icon> </v-btn
            >Sin Contratar
          </v-card-actions>
        </v-flex>
      </v-layout>
      <!-- dialogo    -->
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Esta seguro?</v-card-title>
          <v-card-text>Esta seguro que desea realizar esta accion.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="dialog = false"
              >Cancelar</v-btn
            >
            <v-btn color="green darken-1" flat @click="dialog = false"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialogo -->
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import jwtDecode from "jwt-decode";

export default {
  name: "grid-contratacion",

  components: {
    AlertEmpty,
    Loading,
  },
  props: {
    rowsTable: "",
    tipeView: "",
    itemsDocumento: {},
  },

  data() {
    return {
      loading: false,
      dialog: false,
      id: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      idContrato: "",
      headers: [
        { text: "Rut asociado", align: "left", sortable: false, value: "rut" },
        { text: "RC-Inhabilidad", sortable: false, value: "rc_inhabilitado" },
        {
          text: "Seleccionado Capacitacion",
          sortable: false,
          value: "capacitacion",
        },
        { text: "Resultado Capacitacion", sortable: false, value: "cap_apto" },
        { text: "Estado", sortable: false, value: "estado" },
        {
          text: "Accion disponible para contratacion",
          sortable: false,
          value: "",
        },
      ],
      usuarioLoggedTipe: "",
      bloqueo: Boolean,
      itemsDocumento: [],
      idUserLogged: "",
      proceso: "",
      apto: "",
      capacitacionSelect: [],
      rc_inhabilitadoSelect: [],
      rc_inhabilitadoValue: null,
      capacitacionValue: null,
      cap_aptoSelect: [],
      cap_aptoValue: null,
      regionSelect: [],
      regionValue: null,
      comunaSelect: [],
      comunaValue: null,
      cargoSelect: [],
      cargoValue: null,
      tipo_capSelect: [],
      tipo_capValue: null,
    };
  },
  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idUserLogged = this.$store.getters.userLogged.id;
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;
    this.loadData();
  },

  mounted() {},
  computed: {},
  methods: {
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      // console.log("DEVODED USER:", user);
      return user.perfil.codigo;
    },
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId && contratoCerradoConId.idContrato === this.idContrato) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    async loadCandidatosFilter() {
      this.body = {
        rc_inhabilitado:
          this.rc_inhabilitadoValue && this.rc_inhabilitadoValue != null
            ? this.rc_inhabilitadoValue
            : null,
        capacitacion:
          this.capacitacionValue && this.capacitacionValue != null
            ? this.capacitacionValue
            : null,
        cap_apto:
          this.cap_aptoValue && this.cap_aptoValue != null
            ? this.cap_aptoValue
            : null,
        comuna:
          this.comunaValue && this.comunaValue != null
            ? this.comunaValue
            : null,
        region:
          this.regionValue && this.regionValue != null
            ? this.regionValue
            : null,
        cargo:
          this.cargoValue && this.cargoValue != null ? this.cargoValue : null,
        tipo_cap:
          this.tipo_capValue && this.tipo_capValue != null
            ? this.tipo_capValue
            : null,
        apto: "Apto",
        idContrato: this.idContrato,
        proceso: this.proceso,
      };
      return await axios
        .post("/candidatos/contratacionFilter", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            //window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    async loadData() {
      this.itemsDocumento = await this.loadCandidatosFilter();
      if (this.itemsDocumento.length > 0) {
        this.loadRcInhabilitado();
        this.loadCapacitacionSelect();
        this.loadResultadoSelect();
        this.loadRegionSelect();
        this.loadCargoSelect();
        this.loadComuna();
        this.loadTipoSelect();
        this.alerta = false;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    loadRegionSelect() {
      let reg = [];
      this.itemsDocumento.forEach(function (d) {
        let index = reg.findIndex((x) => x.region == d.region);
        if (index === -1) {
          reg.push(d.region);
        }
      });
      this.regionSelect = reg;
    },
    loadComuna() {
      let rc = [];
      this.itemsDocumento.forEach(function (d) {
        let index = rc.findIndex((x) => x.comuna == d.comuna);
        if (index === -1) {
          rc.push(d.comuna);
        }
      });
      this.comunaSelect = rc;
    },
    loadRcInhabilitado() {
      let rc = [];
      this.itemsDocumento.forEach(function (d) {
        let index = rc.findIndex((x) => x.rc_inhabilitado == d.rc_inhabilitado);
        if (index === -1) {
          rc.push(d.rc_inhabilitado);
        }
      });
      this.rc_inhabilitadoSelect = rc;
    },
    loadCapacitacionSelect() {
      let cap = [];
      this.itemsDocumento.forEach(function (d) {
        let index = cap.findIndex((x) => x.capacitacion == d.capacitacion);
        if (index === -1) {
          cap.push(d.capacitacion);
        }
      });
      this.capacitacionSelect = cap;
    },
    loadResultadoSelect() {
      let res = [];
      this.itemsDocumento.forEach(function (d) {
        let index = res.findIndex((x) => x.cap_apto == d.cap_apto);
        if (index === -1) {
          res.push(d.cap_apto);
        }
      });
      this.cap_aptoSelect = res;
    },
    loadCargoSelect() {
      let car = [];
      this.itemsDocumento.forEach(function (d) {
        let index = car.findIndex((x) => x.cargo == d.cargo);
        if (index === -1) {
          car.push(d.cargo);
        }
      });
      this.cargoSelect = car;
    },
    loadTipoSelect() {
      let tip = [];
      this.itemsDocumento.forEach(function (d) {
        let index = tip.findIndex((x) => x.tipo_cap == d.tipo_cap);
        if (index === -1) {
          tip.push(d.tipo_cap);
        }
      });
      this.tipo_capSelect = tip;
    },
    clear() {
      this.rc_inhabilitadoValue = "";
      this.capacitacionValue = "";
      this.cap_aptoValue = "";
      this.regionValue = "";
      this.comunaValue = "";
      this.cargoValue = "";
      this.tipo_capValue = "";
      this.loadData();
    },
    filterCandidatos() {
      this.filter = true;
      this.loadData();
    },
    viewCandidato(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "CandidatosRegistra",
          params: { id: id, tipeView: "consulta" },
        });
      }, 1000);
    },
    reload() {
      setTimeout(() => {
        this.$parent.$parent.reloadDocumento();
        // this.$router.go(-1)
      }, 1000);
    },
    contratado(id) {
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        idContrato: idContrato,
        id: id,
        estado: "Contratado",
      };
      axios
        .put("/candidatos/updateEstado", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.reload();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
        });
    },
    sinContratar(id) {
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        idContrato: idContrato,
        id: id,
        estado: "No Contratado",
      };
      axios
        .put("/candidatos/updateEstado", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.reload();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.reload();
          }
        });
    },
  },
};
</script>